import classNames from 'classnames';

import { So5RuleValidationState } from '@sorare/core/src/__generated__/globalTypes';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { iconAlertCircle } from '@sorare/core/src/atoms/icons/system/iconAlertCircle.ts';
import { iconCheckCircle } from '@sorare/core/src/atoms/icons/system/iconCheckCircle.ts';
import {
  Horizontal,
  SBHorizontal,
  Vertical,
} from '@sorare/core/src/atoms/layout/flex';
import { BodyM, BodyS } from '@sorare/core/src/atoms/typography';
import type { Color } from '@sorare/core/src/style/types';

import type { FormatRule } from '#src/components/so5/Rules/types.ts';

const colorPerState: Record<So5RuleValidationState, Color> = {
  [So5RuleValidationState.VALID]: 'var(--c-onBase-success)',
  [So5RuleValidationState.INVALID]: 'var(--c-yellow-400)',
  [So5RuleValidationState.VALIDATABLE]: 'var(--c-nd-600)',
};

type Props = {
  rule: FormatRule;
  minified?: boolean;
};

export const ComposeRule = ({ rule, minified }: Props) => {
  return (
    <Vertical key={rule.id} gap={0.5} className={classNames({ minified })}>
      <SBHorizontal>
        <Horizontal>
          {rule.icon}
          <BodyM as="p" bold className={classNames({ truncate: minified })}>
            {rule.label}
          </BodyM>
        </Horizontal>
        {!!rule.validationState?.state && (
          <FontAwesomeIcon
            icon={
              rule.validationState.state === So5RuleValidationState.INVALID
                ? iconAlertCircle
                : iconCheckCircle
            }
            color={colorPerState[rule.validationState.state]}
          />
        )}
      </SBHorizontal>
      {!minified && !!rule.description && (
        <BodyS as="p" color="var(--c-nd-600">
          {rule.description}
        </BodyS>
      )}
      {!minified &&
        rule.validationState?.state === So5RuleValidationState.INVALID &&
        !!rule.validationState.message && (
          <BodyS as="p" color="var(--c-yellow-400)">
            {rule.validationState.message}
          </BodyS>
        )}
    </Vertical>
  );
};
